module.exports = __webpack_public_path__ + "img/menu.7ad61376.svg";